export default {
  name: {
    date: "日期",
    price: "金額",
  },
};
